import React, { useState, useEffect } from "react";
import Axios from "axios";

//COMPONENTS
import MainMap from "./MainMap";

function Controller() {
    const [apiKey, setApiKey] = useState("");
    const [mapID, setMapID] = useState("");
    const [isLoaded, setIsLoaded] = useState(false);

    const [data, setData] = useState({
        mapLat: 0,
        mapLng: 0,
        pinLat: 0,
        pinLng: 0,
        zoom: 0
    });

    useEffect(() => {
        Axios.post("/pods/mapViewer/load")
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setApiKey(data.apiKey);
                    setMapID(data.mapID);
                    setData({
                        mapLat: parseFloat(data.mapData.find((setting) => setting.setting == "mapLat").value),
                        mapLng: parseFloat(data.mapData.find((setting) => setting.setting == "mapLng").value),
                        pinLat: parseFloat(data.mapData.find((setting) => setting.setting == "pinLat").value),
                        pinLng: parseFloat(data.mapData.find((setting) => setting.setting == "pinLng").value),
                        zoom: parseInt(data.mapData.find((setting) => setting.setting == "zoom").value)
                    });

                    setIsLoaded(true);
                }
            })
            .catch((err) => console.log(err));
    }, []);

    return (
        <div>
            {isLoaded && (
                <div>
                    <MainMap apiKey={apiKey} mapID={mapID} mapData={data} />
                </div>
            )}
        </div>
    );
}

export default Controller;
